<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
    </label>
  }

  <p-selectButton
    [id]="id()"
    [attr.data-testid]="id() + '-input'"
    [(ngModel)]="value"
    [options]="visibleOptions()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [disabled]="isReadOnly()"
    [required]="isRequired()"
    [allowEmpty]="allowEmpty()"
    [styleClass]="styleClass()"
    [invalid]="showInvalid()"
    (focusout)="markAsTouched()"
  >
    <ng-template #item let-item>
      <span>{{ item[optionLabel()] | transloco }}</span>
      @if (item[optionIcon()]) {
        <i [class]="item[optionIcon()]"></i>
      }
    </ng-template>
  </p-selectButton>
</div>
